
function setSliderContentId(currentSlide, slider: HTMLElement, sliderForm: novaCmsWidgets.DumelMainSliderForm) {
  const contentId = $(slider).find('.dumel-main-slider__slide.slick-current').attr('data-content-id');
  sliderForm.setContentId(contentId);
}

function init(afterNewSlideAdded?: boolean) {
  let slickCurrentSlide = 0;
  const token = $('meta[name="csrf-token"]').attr('content');
  $('.dumel-main-slider__wrapper').each((idx, slider) => {
    setLoading($(slider), false);
    const mainSliderId = $(slider).attr('data-main-slider-id');
    const isEditMode = slider.hasAttribute('data-slider-edit-mode');
    const playButton1 = $(slider).find('.dumel-main-slider__audio-1');
    const playButton2 = $(slider).find('.dumel-main-slider__audio-2');
    const media1 = $(slider).find('.dumel-main-slider__audio1')[0] as HTMLAudioElement;
    const media2 = $(slider).find('.dumel-main-slider__audio2')[0] as HTMLAudioElement;
    const heroSlidesWrapper = $(slider).find('.dumel-main-slider__hero-slides-wrapper');

    let dumelMainSliderForm: novaCmsWidgets.DumelMainSliderForm;

    function togglePlay(el: HTMLAudioElement) {
      if (!el.paused) {
        el.pause();
      } else {
        el.play();
      }
    }

    playButton1.click(e => {
      e.stopPropagation();
      togglePlay(media1);
      $(e.target).toggleClass('play-active');
    });

    playButton2.click(e => {
      e.stopPropagation();
      togglePlay(media2);
      $(e.target).toggleClass('play-active');
    });

    if (isEditMode) {
      dumelMainSliderForm = $(slider)
        .kendoDumelMainSliderForm({ contentId: '', mainSliderId, token })
        .data('kendoundefinedDumelMainSliderForm');
    }

    const slickSlider = $(slider).find('.dumel-main-slides')
      .on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        moveHeroSlides(nextSlide);
      })
      .on('init', (event, slick) => {

        if (isEditMode) {
          slickCurrentSlide = slick.currentSlide;
          setSliderContentId(slick.currentSlide, slider, dumelMainSliderForm);
        } else {
          const contentId = $(slider).find('.dumel-main-slider__slide.slick-current').attr('data-content-id');
          toggleMediaPanel(contentId);
        }
      })
      .on('afterChange', (event, slick, nextSlide) => {
        if (isEditMode) {
          slickCurrentSlide = slick.currentSlide;
          setSliderContentId(slick.currentSlide, slider, dumelMainSliderForm);
        } else {
          const contentId = $(slider).find('.dumel-main-slider__slide.slick-current').attr('data-content-id');
          toggleMediaPanel(contentId);
        }
      })
      .slick({
        accessibility: isEditMode ? false : false,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: !isEditMode,
        swipe: !isEditMode,
        prevArrow: `
          <button type="button" class="dumel-main-slider__navigation dumel-main-slider__navigation--prev">
            <svg version="1.1" id="Warstwa_1" x="0px" y="0px" viewBox="0 0 12.1 18.7" xml:space="preserve"
              class="dumel-main-slider__navigation-arrow" fill="currentColor">
              <path class="st0" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
            c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
            s-0.7-0.1-1-0.4L0.4,10.4z" />
            </svg>
          </button>
        `,
        nextArrow: `
          <button type="button" class="dumel-main-slider__navigation dumel-main-slider__navigation--next">
            <svg version="1.1" id="Warstwa_1" x="0px" y="0px" viewBox="0 0 12.1 18.7" xml:space="preserve"
              class="dumel-main-slider__navigation-arrow dumel-main-slider__navigation-arrow--right" fill="currentColor" >
              <path class="st0" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
              c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
              s-0.7-0.1-1-0.4L0.4,10.4z" />
            </svg>
          </button>
        `
      });

    if (afterNewSlideAdded) {
      const slideCount = (slickSlider.slick('getSlick') as any).slideCount;
      slickSlider.slick('slickGoTo', slideCount - 1);
    }

    if (isEditMode) {
      dumelMainSliderForm.bind('DumelMainSliderRemoveSlide', (contentId) => {
        const slideCount = (slickSlider.slick('getSlick') as any).slideCount;
        setLoading($(slider), true);

        if (slideCount <= 1) {
          return;
        }

        const contentDataSetter = new novaCmsDataSets.ContentDataSet(token, contentId);
        contentDataSetter.readData().then(() => {
          contentDataSetter.deleteData();
          contentDataSetter.saveData().then(() => {
            slickSlider.slick('slickRemove', slickCurrentSlide);
            slickSlider.slick('slickGoTo', 0);
            slickSlider.slick('unslick');
            init(false);
          });
        }, err => console.log(err))
          .then(() => {
            setLoading($(slider), false);
          });
      });

      dumelMainSliderForm.bind('DumelMainSliderAddSlide', () => {
        setLoading($(slider), true);
        const contentDataSetter = new novaCmsDataSets.ContentDataSet(token);
        contentDataSetter.dataRow.set('ParentId', mainSliderId);
        contentDataSetter.dataRow.set('RootId', mainSliderId);
        const newContentOptions: novaCmsWidgets.DumelMainSliderContent = {
          title: 'Tytuł',
          description: 'Opis',
          link: null,
          mediaOptions: [
            {
              audio: null,
              link: null,
              label: null,
              mediaActive: null,
              slotType: 2
            },
            {
              audio: null,
              link: null,
              label: null,
              mediaActive: null,
              slotType: 2
            }
          ]
        };
        contentDataSetter.dataRow.set('ContentOptions', JSON.stringify(newContentOptions));
        contentDataSetter.saveData().then(() => {
          const newContentId = contentDataSetter.dataRow.get('ContentId');
          slickSlider.slick('unslick');
          const clonedContent = slickSlider.find('.dumel-main-slider__slide').first().clone();
          const clonedHero = $(slider).find('.dumel-main-slider__hero-wrapper').first().clone();
          $(slider).find('.dumel-main-slider__media-panel').first().attr('data-content-id', newContentId);
          const slideBg = clonedContent.find('.dumel-main-slider__image');
          const slideHeroBg = clonedHero.find('.dumel-main-slider__image');
          slideBg.css('background-color', '#99ccff');
          slideBg.css('background-image', 'none');
          slideHeroBg.css('background-color', '#ccccff');
          slideHeroBg.css('background-image', 'none');
          clonedContent.attr('data-content-id', newContentId);
          clonedHero.attr('data-content-id', newContentId);
          dumelMainSliderForm.destroy();
          heroSlidesWrapper.append(clonedHero);
          slickSlider.append(clonedContent);
          init(true);
        }, err => console.log(err));
      });

      dumelMainSliderForm.bind('DumelMainSliderSaveSlide', (model) => {
        setLoading($(slider), true);
        const contentDataSetter = new novaCmsDataSets.ContentDataSet(token, model.contentId);
        contentDataSetter.readData().then(() => {
          contentDataSetter.dataRow.set('ContentOptions', JSON.stringify(model.slideModelToSend));
          contentDataSetter.saveData();
        }, err => console.log(err)
        ).then(() => setLoading($(slider), false));
      });
    }

    function moveHeroSlides(currentSlide: number) {
      const translateValue = `calc(-${currentSlide} * 100%)`;
      heroSlidesWrapper.css('transform', 'translateX(' + translateValue + ')');
    }

    function setLoading(currentSlider: JQuery, isLoading: boolean) {
      if (isLoading) {
        currentSlider.addClass('dumel-main-slider__wrapper--blocked');
      } else {
        currentSlider.removeClass('dumel-main-slider__wrapper--blocked');
      }
    }

    function toggleMediaPanel(contentId: string) {
      const slides = $(slider).find('.dumel-main-slider__media-panel');
      const sliderMediaPanelActiveClass = 'dumel-main-slider__media-panel-active';
      slides.removeClass(sliderMediaPanelActiveClass);
      slides.filter(`[data-content-id=${contentId}]`).addClass(sliderMediaPanelActiveClass);
    }
  });
}

($ => {
  $(document).ready(() => {
    init();
  });
})(jQuery);
